module.exports = __webpack_public_path__ + "static/media/etsy-clay-kit.2cd0099f.png";